const NEW_APP = 'New Application'
const FEEDBACK_TYPE = 'Feedback Type'
const COMMENT = 'Comment'
const QUESTION = 'Question'
const MESSAGE = 'Message'
const BUG_REPORT = 'Bug Report'

export { NEW_APP, FEEDBACK_TYPE, COMMENT, BUG_REPORT, QUESTION, MESSAGE }
